import { Avatar, Checkbox, Input, Spin } from "antd";
import { useEffect, useRef, useState } from "react";
import useOutsideAlerter from "shared/hooks/useOutsideAlerter";
import { DeleteOutlined, LoadingOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

const SocialList: React.FC<any> = (props) => {
  const {
    placeholder,
    checkboxLabel,
    label,
    logo,
    value,
    onChange,
    getListOptions,
    showMore,
    onSelectCallback = () => {},
    showDefaultImage = true,
    offsetTop = 0,
    bottomDefault = 180,
    prefix,
  } = props;
  const [searchField, setSearchField] = useState("");
  const [showList, setShowList] = useState(false);
  const [bottomStyle, setBottomStyle] = useState<any>("auto");
  const [options, setOptions] = useState<any[]>([]);
  const [selectedOption, setSelectedOption] = useState<any>(value);
  const wrapperRef = useRef<any>(null);
  const inputRef = useRef<any>(null);
  const [inputWidth, setInputWidth] = useState<any>("auto");
  const [offset, setOffset] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);
  const { t } = useTranslation();
  useOutsideAlerter(wrapperRef, handleClickOutside);

  const openList = () => {
    const menuEl = wrapperRef.current;
    const menuRect = menuEl.getBoundingClientRect();
    const screenHeight = window.innerHeight;
    if (menuRect.bottom - screenHeight + 270 > 0) {
      setBottomStyle(108);
    } else {
      setBottomStyle("");
    }
    setShowList(true);
  };

  function handleClickOutside(event: any) {
    if (wrapperRef.current && !wrapperRef.current?.contains(event.target)) {
      setShowList(false);
    }
  }

  const searchOptions = async () => {
    if (!searchField.trim() || loading) {
      return;
    }
    setLoading(true);
    const list: any = await getListOptions(searchField);
    setOptions(list);
    if (list.length) openList();
    setLoading(false);
  };

  const searchOptionsOffset = async (position: number = 0) => {
    if (loading) return;
    setLoading(true);
    try {
      const list: any = await getListOptions(searchField, position);

      setOptions((prev) => [...prev, ...list]);
      openList();
      setOffset(position);
    } catch (error) {
      console.error("Error fetching options:", error);
    } finally {
      setLoading(false);
    }
  };

  const onKeyPress = (event: any) => {
    if (event.which === 13) {
      searchOptions();
    }
  };

  const onClickNoValue = (checked: boolean) => {
    if (checked) {
      const noDataValue = { id: "no-data" };
      onChange(noDataValue);
      setSelectedOption(noDataValue);
      onSelectCallback(false);
    } else {
      onChange();
      setSelectedOption(undefined);
    }
  };

  const onSelectValue = (option: any) => {
    const { id, name, avatarUrl } = option;
    if (id) {
      onChange({ id, name, avatarUrl, ...option });
      setSelectedOption(option);
      setShowList(false);
      onSelectCallback(true);
    }
  };

  const handleDeleteClick = () => {
    setSelectedOption(undefined);
    onChange();
    onSelectCallback(false);
  };

  const handleClickShowMore = () => {
    searchOptionsOffset(offset + 50);
  };

  useEffect(() => {
    if (showList && wrapperRef.current && inputRef.current) {
      const menuEl = wrapperRef.current;
      const menuRect = menuEl?.getBoundingClientRect();
      const screenHeight = window.innerHeight;
      if (menuRect.bottom - screenHeight + 270 > 0) {
        setBottomStyle(bottomDefault);
      } else {
        setBottomStyle("");
      }
      const inputElement = inputRef.current.input;
      if (inputElement) {
        const width = inputElement.getBoundingClientRect().width;
        setInputWidth(width);
      }
    }
  }, [showList, bottomDefault]);

  // if (selectedOption && selectedOption.id !== "no-data")
  //   return (
  //     <div className="selected-item">
  //       <Avatar style={{ marginRight: "6px" }} src={selectedOption.avatarUrl} />
  //       <span>{selectedOption.name || selectedOption.id}</span>
  //       <DeleteOutlined className="remove" onClick={handleDeleteClick} />
  //     </div>
  //   );

  return (
    <div ref={wrapperRef} className="caixa-input">
      <div className="container">
        {selectedOption?.avatarUrl ? (
          <img
            src={selectedOption?.avatarUrl}
            className="avatar-imagem"
            alt="icon"
          />
        ) : (
          showDefaultImage && <div className="container-logo">{logo}</div>
        )}
        <div className="label">
          <span style={{ display: "flex", gap: 9 }}>
            {logo}
            {label}
          </span>
          <span style={{ color: "#33CAE3" }}>
            {selectedOption &&
              selectedOption.id !== "no-data" &&
              (selectedOption.name || selectedOption.id)}
          </span>
        </div>
      </div>
      {selectedOption && (
        <DeleteOutlined className="remove" onClick={handleDeleteClick} />
      )}
      {(!selectedOption?.id || selectedOption?.id === "no-data") && (
        <>
          <Input
            ref={inputRef}
            placeholder={placeholder}
            onChange={(event) => setSearchField(event.target.value)}
            onKeyPress={onKeyPress}
            disabled={value?.id === "no-data"}
            style={{ marginTop: 14 }}
            onClick={() =>
              !showList && options.length > 0 ? openList() : setShowList(false)
            }
            prefix={prefix}
            suffix={
              <button
                className="botao-roxo"
                style={{ padding: 0, borderRadius: 2, position: "relative" }}
                onClick={() => searchOptions()}
                type="button"
                disabled={loading}
              >
                {t("quiz.pages.Questionario.buscar")}{" "}
                {loading && (
                  <Spin
                    style={{ position: "absolute" }}
                    size="small"
                    indicator={
                      <LoadingOutlined
                        style={{ fontSize: 16, color: "#ececec" }}
                        spin
                      />
                    }
                  />
                )}
              </button>
            }
          />
          {showList && (
            <div
              className="dropdown-modal"
              style={{
                bottom: bottomStyle,
                width: inputWidth + 106,
                top: bottomStyle ? "unset" : 145 + offsetTop,
              }}
            >
              {options.map((option: any, index: number) => (
                <div
                  className="conteudo"
                  onClick={() => {
                    onSelectValue(option);
                  }}
                  key={`option-${index}`}
                >
                  <div>
                    {option.avatarUrl && (
                      <Avatar
                        style={{ marginRight: 6 }}
                        src={option.avatarUrl}
                      />
                    )}
                    {option.name}
                  </div>
                  {option?.id && (
                    <div className="selecionar">
                      {t("quiz.pages.Questionario.selecionar")}
                    </div>
                  )}
                </div>
              ))}
              {showMore && options.length % 50 === 0 && (
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <button
                    className="botao-roxo"
                    style={{ padding: 0, borderRadius: 2 }}
                    onClick={handleClickShowMore}
                    type="button"
                  >
                    {t("quiz.pages.Questionario.mais")}
                  </button>
                </div>
              )}
            </div>
          )}
          {checkboxLabel && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                marginTop: 6,
              }}
            >
              <Checkbox
                onChange={({ target: { checked } }) => onClickNoValue(checked)}
                checked={value?.id === "no-data"}
              >
                <span>{checkboxLabel}</span>
              </Checkbox>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default SocialList;
